// The Premium v2 shell of the four main screens (PREMIUM_TODAY_ENABLED, 2026-10-23): ONE fixed bottom bar + the
// scroll position each tab opens at.
//
// The app scrolls ONE container — the window (every screen is a min-h-screen page in the document flow); App.js swaps
// the screen in place, so the window kept the previous screen's scroll position, and the chat's scroll-to-latest
// (messagesEndRef.scrollIntoView) scrolled the whole WINDOW to the bottom. So:
//   Today / Plan / Activities -> the window is reset to the top when the tab opens (never on a re-render / refresh).
//   Coach -> the chat page is sized to the viewport above the bar (index.css .premium-chat-page), so its own message
//            list (<main class="overflow-y-auto">) is the scroll container: the chat's scroll-to-latest moves the list
//            only, the composer stays directly above the bar, and the window stays at the top.
import React, { useLayoutEffect } from 'react';
import { PremiumBottomNav } from './PremiumToday';

export const TOP_ON_OPEN = new Set(['home', 'weekly-plan', 'activities', 'profile']);

export function resetWindowScroll(win = window) {
  try { win.scrollTo(0, 0); } catch { /* jsdom / blocked */ }
  try {
    if (win.document && win.document.scrollingElement) win.document.scrollingElement.scrollTop = 0;
  } catch { /* */ }
}

export default function PremiumNavShell({ active, onNavigate, children, Nav = PremiumBottomNav }) {
  // Runs when the tab OPENS (mount, or `active` changes) — not on the screen's own data refreshes / re-renders.
  useLayoutEffect(() => {
    resetWindowScroll();
  }, [active]);
  return (
    <div className={`premium-nav-page${active === 'chat' ? ' premium-chat-page' : ''}`} data-testid="premium-shell"
         data-active={active}>
      {children}
      <Nav active={active} onNavigate={onNavigate} />
    </div>
  );
}
